import React, { useState, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { StyledDataGrid } from "../Theme/styledComponents";
import MyDataGrid from "../UI/DataGrid";

function ModiSSIadmin({ analysisResult }) {
  const [modiSsiAdminRows, setModiSsiAdminRows] = useState([]);
  const [modiSsiAdminColumns, setModiSsiAdminColumns] = useState([]);
  const [tableWidth, setTableWidth] = useState("80vw");

  useEffect(() => {
    let modi_ssi_admin_columns = [
      {
        field: "measurement_name",
        headerName: "Name",
        flex: 1,
      },
    ];
    let modi_ssi_admin_rows = [];
    analysisResult.result.frequenze_trovate_SSI.forEach((freq_ssi, index) => {
      modi_ssi_admin_columns.push({
        field: "modi_ssi_admin_" + index,
        headerName: "Modo " + (index + 1),
        flex: 1,
      });
    });
    setModiSsiAdminColumns(modi_ssi_admin_columns);
    analysisResult.result.modi_trovati_SSI.forEach((modi_ssi, index) => {
      let row = {
        id: "modi_ssi_admin_" + index,
        measurement_name: "Sens. " + (index + 1),
      };
      modi_ssi.forEach((modo, i) => {
        row["modi_ssi_admin_" + i] = modo;
      });
      modi_ssi_admin_rows.push(row);
    });
    setModiSsiAdminRows(modi_ssi_admin_rows);
  }, [analysisResult]);
  useEffect(() => {
    let totalWidth = 0;
    modiSsiAdminColumns.forEach((column) => {
      totalWidth += column.width;
    });
    setTableWidth(totalWidth);
  }, [modiSsiAdminColumns]);

  return (
    <>
      <Box>
        <Typography variant='h5' color="text.secondary" fontWeight={600} >
          7. Tabella con i modi selezionati per gli indici di danno - SOLO PER
          SUPER ADMIN
        </Typography>
        <Typography variant='subtitle2' color="text.secondary" fontWeight={400} >
          Lunghezza di frequenze trovate SSI
        </Typography>

      </Box>
      <Box
        id={"IndiciDanno-table-admin"}
        sx={{
          height: 700,
          // width: tableWidth || "80vw",
          // maxWidth: "80vw",
        }}
      >
        <MyDataGrid
          rows={modiSsiAdminRows}
          columns={modiSsiAdminColumns}
        />
      </Box>
    </>
  );
}

export default ModiSSIadmin;